
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import uploadFile from "@/utils/DZUploadFile";
import nyMessageToast from "@/utils/NYMessageToast";
import ny_config from "@/api/nyConfig";
import api from "@/api/nyApiJson";

@Component({
    components: { Editor, Toolbar }
})
export default class UIEditor extends Vue {

    baseUrl = process.env.VUE_APP_BaseURL

    @Prop() data;

    html = "";

    editor = null;

    toolbarConfig = {};

    editorConfig = {
      MENU_CONF:{
        uploadImage:{
          async customUpload(file,insertFn){
            uploadFile.uploadImage(file,
                (res) => {
                }, (res) => {
                  let apiJson: ny_config = api["显示图片"];
                  const url = apiJson.baseUrl + apiJson.url + "?image=" + res;
                  insertFn(url,res,res)
                }, (res) => {
                  nyMessageToast.error("图片上传失败")

                });
          }
        }
      },
      placeholder: '请输入内容...'
    };

    mode = 'simple'; // or 'default '

    created() { }

    mounted() {
    }

    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }

    @Watch("data")
    watchData(value: any, oldValue: string) {
        this.html = value;
    }
    @Watch("html")
    watchDataHtml(value: any, oldValue: string) {
        this.$emit('editor_change', this.html);
    }

    onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        this.html = this.data;
    }

}
